<template>
    <div :class="['techInfo',getPlatformClass]">
        <!--<div class="attachedLogo White"></div>-->
        <div class="sectionTitle black fsTitle">
          <!-- <splitter :content="ms_localize(sectionData.title)"></splitter> -->
          {{ms_localize(sectionData.title)}}
        </div>

        <div :class="['info', isTechFadeout === true ? 'infoFadeout' : '']">
          <div class="infItem" v-for="(item,index) in sectionData.contents" :key="index">
            <splitter :content="ms_localize(item)"></splitter>
          </div>
        </div>

        <div :class="['imgContainer', isTechFadeout === true ? 'techImgFadeout' : '']">
          <!-- information image -->
          <img class="itemImg" :src="infoImg" />
        </div>

        <div :class="['platformBarContainer',plaformIndex>-1 ? 'mounted':'']">
          <platformbar 
            v-bind:affectOtherSections = "false"
            v-bind:sectionIndex = "3"
            skinMode = "light"
            @platform-change="onPlatformChange" 
            @item-change="onItemChange">
          </platformbar>
        </div>

    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines } from "@/utils";
import platformbar from "@/views/com/platformbar.vue";
import splitter from "@/views/com/splitter.vue";

export default {
    name: "techInfo",
    components:{platformbar,splitter},
    props: {
        sectionDataIndex:Number,
        isNavOpen: Boolean
    },
    data()
    {
        return {
            plaformIndex:-1,
            infoImg:'',
            isTechFadeout:true
        }
    },
    watch: {
      '$store.state.xSelectedPlatform': function() {
        //alert("xP="+this.$store.state.xSelectedPlatform);
        this.onPlatformChange(this.$store.state.xSelectedPlatform);
      }
    },
    methods:
    {
      onPlatformChange(plaformIndex)
      {
        var vm = this;        
        vm.isTechFadeout = true;
        
        setTimeout(() => {
          vm.plaformIndex = plaformIndex;
          vm.infoImg = this.sectionData.platforms[plaformIndex].img;
        }, 500);

        setTimeout(() => {
          vm.isTechFadeout = false;
        }, 1100);

        //this.plaformIndex = plaformIndex;
        //this.infoImg = this.sectionData.platforms[plaformIndex].img;
      },
      onItemChange(catalogNo)
      {
        //nothing
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["xSelectedPlatform","minisite_data","siteDataReady"]),
        getStorePlatform()
        {
          return this.xSelectedPlatform;//
        },
        getPlatformClass()
        {
          //We can finally animate CSS gradient:
          //https://dev.to/afif/we-can-finally-animate-css-gradient-kdk
          return this.plaformIndex>-1 ? "platform_"+this.plaformIndex: '';
        },
        sectionData(){
            return this.minisite_data.SECTIONS[this.sectionDataIndex];
        }

    }
};

</script>


<style>
    @property --c {
      syntax: '<color>';
      inherits: false;
      initial-value: red;
    }

    .techInfo
    {      
        position:relative;
        width: 100vw;
        height: 100%;
        
        z-index: 100;
        display: grid;
        align-items: center;

        background-color: var(--graybg1);
        --c:var(--dark-blue);
        transition:--c 0.6s;
        /*
        background: radial-gradient(circle, var(--c) 0%,var(--dark-blue) 50%);
        */ 
    }
    
    .techInfo.platform_0{--c:#2a2512;}
    .techInfo.platform_1{--c:#241128;}
    .techInfo.platform_2{--c:#241128;}
    .techInfo.platform_3{--c:#0f250e;}

    .techInfo .container
    {
      width: 100vw;
    }
    .techInfo .title
    {
        font-size: 22px !important;
        font-weight: 100 !important;        
        letter-spacing: -0.5px;
        color: #fff;
        text-align:center;        
        position:absolute;
        top:0px;left: 0px;
        /*padding-left: max(180px, 10vw);*/
        top:100px;width: 100%;
        
    }
    .techInfo .info
    {
        position:absolute;
        left: 0px;
        top: calc(100vh - 310px);
        /* padding-left: max(180px, 10vw);         */
        opacity: 1;
        padding-left: calc(24vw / 2);

    }
    .techInfo .info.infoFadeout
    {
      opacity: 0;
    }

    .techInfo .info .infItem:nth-child(1)
    {
      font-weight: bold;
    }
    .techInfo .info .infItem
    {
      padding-top: 3px;
      font-size: 18px;
      text-align: left;        
      color: #202020;
    }


    .techInfo .platformBarContainer
    {
      transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      position: absolute;
      top:50%;
      transform: translateY(-50%);
      width: 100%;
    }
    .techInfo .platformBarContainer.mounted
    {
      top:calc(100vh - 120px);
    }    

    .techInfo .imgContainer
    {
      position: absolute;top:47%;transform: translateY(-50%);
      width: 100%;text-align: center;
      color:#fff;
      pointer-events: none;
      opacity: 1;
      transition: all ease 0.8s;
    }
    .imgContainer.techImgFadeout
    {
      opacity: 0;
    }
    .imgContainer .itemImg
    {
      height: 46vh;width:auto;
    }
    .imgContainer .itemTitle
    {
      padding-top: 20px;
      font-size: 14px;color: #fff;font-weight: 300;text-align: center;
    }

  @media (hover: hover) {
  }

  @media (max-width: 850px) { 
    .techInfo
    {      
      min-height: 30vh;
      width: 100vw !important;
      height: auto;
      display: block;
      margin-bottom: 100px;      
    }    
    .techInfo .title
    {
      position: initial;
      padding-top: 100px;
      padding-left: 10vw;
      text-align: left;
    }    
    .techInfo .info
    {
        position:initial;
        padding-top: 30px;
        transform: none;
        padding-left: 10vw;
    }    
    .techInfo .imgContainer
    {
        position: initial;
        transform:none;
        padding-top: 40px;
    }
    .techInfo .platformBarContainer
    {
      position: static;
      transform: translateY(0%);
      width: 100%;
      /* padding: 50px 0px 50px 0px; */
      padding: 50px 0px 0px 0px;
    }    
    .techInfo .platformBarContainer.mounted
    {

    }    

  }  
</style>